import { render, staticRenderFns } from "./collab_task_list.vue?vue&type=template&id=29036c3f&scoped=true"
import script from "./collab_task_list.vue?vue&type=script&lang=js"
export * from "./collab_task_list.vue?vue&type=script&lang=js"
import style0 from "./collab_task_list.vue?vue&type=style&index=0&id=29036c3f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29036c3f",
  null
  
)

export default component.exports